import React from "react";
import CareerContactPage from "./career_form";
import MapComponent from "../../components/map_component";
import Footer from "../../components/footer";

const CareersPage = () => {
  return (
    <div>
      <CareerContactPage />
      <MapComponent />
      <Footer />
    </div>
  );
};

export default CareersPage;
